function parseCode(search) {
  // Returns [isValid, state, code]
  // On a successful authorization Spotify redirects back with the auth code and
  // state in the query string, e.g. "?code=AQD...&state=abc123".
  const params = new URLSearchParams(search);
  const code = params.get("code");
  const state = params.get("state");
  if (code === null || state === null) {
    return [false, null, null];
  }
  return [true, state, code];
}

function parseSearch(search) {
  // Returns [isValid, state, error]
  const errorRegex = /\?error=([^&]*)/;
  const errorFound = search.match(errorRegex);
  if (!errorFound) {
    return [false, null, null];
  }

  const stateRegex = /&state=([^&]*)/;
  const stateFound = search.match(stateRegex);
  if (!stateFound) {
    return [false, null, null];
  }

  return [true, stateFound[1], errorFound[1]];
}

function randNonce(length) {
  let text = "";
  let possible =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (let i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
}

async function generateCodeChallenge(codeVerifier) {
  // Produces the base64url-encoded SHA-256 of the verifier, as required by the
  // Authorization Code with PKCE flow (code_challenge_method=S256).
  const data = new TextEncoder().encode(codeVerifier);
  const digest = await window.crypto.subtle.digest("SHA-256", data);
  const bytes = new Uint8Array(digest);
  let binary = "";
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary)
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
}

async function exchangeCodeForToken(tokenEndpoint, params) {
  // Returns [isValid, accessToken]
  // Exchanges an authorization code for an access token using PKCE. No client
  // secret is used, which is what makes this flow safe for a browser-only app.
  const { code, codeVerifier, clientId, redirectUri } = params;
  const body = new URLSearchParams({
    grant_type: "authorization_code",
    code,
    redirect_uri: redirectUri,
    client_id: clientId,
    code_verifier: codeVerifier,
  });

  try {
    const response = await fetch(tokenEndpoint, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: body.toString(),
    });
    if (!response.ok) {
      return [false, null];
    }
    const data = await response.json();
    if (!data.access_token) {
      return [false, null];
    }
    return [true, data.access_token];
  } catch (error) {
    return [false, null];
  }
}

export {
  parseCode,
  parseSearch,
  randNonce,
  generateCodeChallenge,
  exchangeCodeForToken,
};
